import { useCities } from "@/common/hooks/queries/useCities";
import useDebounce from "@/common/hooks/useDebounce";
import { GeoTransformers } from "@/common/services/geoTransformers";
import { Mapper } from "@/common/services/mapper";
import { DashboardFilterProps, DashboardFilters } from "@/features/company/types/dashboards/dashboard.type";
import DashboardFilterSheet from "../DashboardFilterSheet";

const DashboardFilterCitySheet = ({ filters, setFilters }: DashboardFilterProps) => {
  const [search, setSearch, instantSearch] = useDebounce('');

  const {
    data: cityOptions,
  } = useCities({
    filters: {
      search,
    },
    mapper: Mapper.mapWithTransformer({
      transformer: GeoTransformers.optionsTransformer()
    }),
  });

  return (
    <DashboardFilterSheet
      filterKey={DashboardFilters.City}
      options={cityOptions}
      filters={filters}
      setFilters={setFilters}
      instantSearch={instantSearch}
      setSearch={setSearch}
    />
  );
}

export default DashboardFilterCitySheet;
